import React, { Component } from "react";

import { Icon, Menu } from 'semantic-ui-react'
import { injectIntl, defineMessages, FormattedMessage, } from "react-intl";

const messages = defineMessages({
    lucky: {
        id: 'app.creations.lucky',
        defaultMessage: 'Feeling Lucky'
    },
    register: {
        id: 'app.creations.register',
        defaultMessage: 'Register'
    },
    login: {
        id: 'app.creations.login',
        defaultMessage: 'Login'
    }
})

class CreationMenu extends Component {

    state = { activeItem: 'home' }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })



    render() {
        console.log("i am rerender the menu")
        const { activeItem } = this.state

        const { intl: { formatMessage } } = this.props;

        return (

                  <div></div>


        )
    }
}

export default injectIntl(CreationMenu)